(() => {
  if(!window.customElements || customElements.get('lumidog-cart'))return;
  customElements.define('lumidog-cart',class extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;this.busy=false;
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-quantity-step]');
        if(button){
          const input=button.closest('[data-cart-row]').querySelector('[data-cart-quantity]');
          if(this.busy)return;
          input.value=Math.max(0,Number(input.value || 0)+Number(button.dataset.quantityStep));
          this.schedule(input);return;
        }
        const remove=event.target.closest('[data-cart-remove]');
        if(remove){event.preventDefault();if(this.busy)return;const input=remove.closest('[data-cart-row]').querySelector('[data-cart-quantity]');input.value=0;this.schedule(input);}
      });
      this.addEventListener('change',event=>{if(event.target.matches('[data-cart-quantity]'))this.schedule(event.target);});
      this.addEventListener('submit',event=>{clearTimeout(this.timer);if(this.busy)event.preventDefault();});
    }
    disconnectedCallback(){clearTimeout(this.timer);}
    schedule(input){
      if(!input.checkValidity()){input.reportValidity();return;}
      clearTimeout(this.timer);
      this.timer=setTimeout(()=>this.update(input),250);
    }
    async update(input){
      if(this.busy)return;
      this.busy=true;this.setAttribute('aria-busy','true');
      const status=this.querySelector('[data-cart-status]');
      const label=this.dataset.updated;
      status.textContent=this.dataset.updating;
      this.querySelectorAll('button,input').forEach(control=>control.disabled=true);
      try{
        const updates={};
        this.querySelectorAll('[data-cart-quantity]').forEach(field=>{updates[field.dataset.lineKey]=Number(field.value);});
        const response=await fetch(this.dataset.updateUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates,sections:[this.dataset.sectionId],sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok)throw new Error('cart');
        const html=result.sections?.[this.dataset.sectionId];
        if(!html){location.reload();return;}
        const parsed=new DOMParser().parseFromString(html,'text/html');
        const next=parsed.querySelector('lumidog-cart');
        if(!next){location.reload();return;}
        const index=[...this.querySelectorAll('[data-cart-quantity]')].indexOf(input);
        this.replaceWith(next);
        document.querySelectorAll('.cart-count').forEach(count=>count.textContent=result.item_count);
        const announcement=next.querySelector('[data-cart-status]');
        if(announcement)announcement.textContent=label;
        const target=next.querySelectorAll('[data-cart-quantity]')[index] || next.querySelector('[name="checkout"]') || next.querySelector('a');
        target?.focus({preventScroll:true});
      }catch{
        this.busy=false;this.removeAttribute('aria-busy');
        this.querySelectorAll('button,input').forEach(control=>control.disabled=false);
        status.textContent=this.dataset.error;
      }
    }
  });
})();
